<template>
  <div>
    <BreadcrumbBanner
      :pageTitle="$t('Recent Viewed')"
      :links="[
        { name: $t('Home'), url: '/' },
        { name: $t('Recent Viewed') }
      ]"
    />

    <!--Recent Viewed-->
    <div class="casino-demo pb-60 pb-60 mt-4" v-if="games.length > 0">
      <div class="container-fluid">
        <div class="all-games-wrapper">
          <div class="section-wrapper">
            <h4 class="left-title live-text d-flex align-items-center">
              <span class="icon"
                ><img src="@/assets/img/favarites/love.png" alt="badge"
              /></span>
              {{ $t("Recent Viewed") }} <span class="text-base text">{{ games.length }}</span>
            </h4>
          </div>
          <div class="row g-3">
            <div v-for="game in games" :key="game.id" class="col-xxl-3 col-xl-4 col-md-4 col-sm-6">
              <GameCard :game="game" />
            </div>
          </div>
        </div>
      </div>
      <div class="more-btn text-center bt" v-if="nextPage != null">
        <a href="javascript:;" class="border-btn" @click="loadMore">
          <span>{{ $t("Load more") }}</span>
        </a>
      </div>
    </div>
    <div class="recent-view" v-else>
      <div class="container-fluid">
        <div class="recent-content">
          <h2>{{ $t("No view history") }}!</h2>
        </div>
      </div>
    </div>
    <!--Recent Viewed-->
  </div>
</template>

<script>
import BreadcrumbBanner from "@/components/partials/Breadcumnd.vue";
import { useRecentGamesStore } from "@/store/recentGames";
import { mapState, mapActions } from "pinia";
import GameCard from "@/components/partials/GameCard.vue";

export default {
  name: "RecentViewPage",
  components: {
    BreadcrumbBanner,
    GameCard,
  },
  computed: {
    ...mapState(useRecentGamesStore, ["games", "nextPage"]),
  },
  methods: {
    ...mapActions(useRecentGamesStore, ["loadRecentViews"]),
    async loadMore() {
      await this.loadRecentViews();
    },
  },
  async mounted() {
    this.nextPage = 1;
    await this.loadRecentViews();
  },
};
</script>
